import { createRoutine } from 'redux-saga-routines';
import { ACTION_SOFT_RESET } from '@/constants';

export default createRoutine(ACTION_SOFT_RESET);
